import { ApprovalMethodTypeDTO } from 'anchor-ts-infra/src/dto/approval-method/dto';
export let InvoicePaymentMethodStatus = /*#__PURE__*/function (InvoicePaymentMethodStatus) {
  InvoicePaymentMethodStatus["PaymentMethodSet"] = "paymentMethodSet";
  InvoicePaymentMethodStatus["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentMethodStatus["PaymentMethodUnverified"] = "paymentMethodUnverified";
  return InvoicePaymentMethodStatus;
}({});
export let InvoiceDisplayStatus = /*#__PURE__*/function (InvoiceDisplayStatus) {
  InvoiceDisplayStatus["Issued"] = "issued";
  InvoiceDisplayStatus["PaymentInitiated"] = "paymentInitiated";
  InvoiceDisplayStatus["Paid"] = "paid";
  InvoiceDisplayStatus["Overdue"] = "overdue";
  InvoiceDisplayStatus["Voided"] = "voided";
  InvoiceDisplayStatus["Refunded"] = "refunded";
  InvoiceDisplayStatus["RefundFailed"] = "refundFailed";
  InvoiceDisplayStatus["PaymentDisputed"] = "disputed";
  return InvoiceDisplayStatus;
}({});
export let InvoicePaymentDisplayStatusType = /*#__PURE__*/function (InvoicePaymentDisplayStatusType) {
  InvoicePaymentDisplayStatusType["PaymentMethodNotSet"] = "paymentMethodNotSet";
  InvoicePaymentDisplayStatusType["PaymentMethodUnverified"] = "paymentMethodUnverified";
  InvoicePaymentDisplayStatusType["PaymentFailed"] = "paymentFailed";
  InvoicePaymentDisplayStatusType["Paid"] = "paid";
  InvoicePaymentDisplayStatusType["PaidExternally"] = "paidExternally";
  InvoicePaymentDisplayStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoicePaymentDisplayStatusType["RequiresPaymentValidation"] = "requiresPaymentValidation";
  InvoicePaymentDisplayStatusType["Processing"] = "processing";
  InvoicePaymentDisplayStatusType["Collected"] = "collected";
  InvoicePaymentDisplayStatusType["Refunded"] = "refunded";
  InvoicePaymentDisplayStatusType["RefundFailed"] = "refundFailed";
  InvoicePaymentDisplayStatusType["RefundRequested"] = "refundRequested";
  InvoicePaymentDisplayStatusType["Pending"] = "pending";
  InvoicePaymentDisplayStatusType["StoppedPayment"] = "stoppedPayment";
  InvoicePaymentDisplayStatusType["Disputed"] = "disputed";
  return InvoicePaymentDisplayStatusType;
}({});
export { ApprovalMethodTypeDTO as ApprovalMethodType };
export let InvoiceStatusEnum = /*#__PURE__*/function (InvoiceStatusEnum) {
  InvoiceStatusEnum["RequiresPaymentApproval"] = "requiresPaymentApproval";
  InvoiceStatusEnum["PaymentActionRequired"] = "paymentActionRequired";
  InvoiceStatusEnum["PaymentFailed"] = "paymentFailed";
  InvoiceStatusEnum["Pending"] = "pending";
  InvoiceStatusEnum["ProcessingCharge"] = "processingCharge";
  InvoiceStatusEnum["PaymentConfirmed"] = "paymentConfirmed";
  InvoiceStatusEnum["Paid"] = "paid";
  InvoiceStatusEnum["PaidExternally"] = "paidExternally";
  InvoiceStatusEnum["Voided"] = "voided";
  InvoiceStatusEnum["Refunded"] = "refunded";
  InvoiceStatusEnum["RefundFailed"] = "refundFailed";
  InvoiceStatusEnum["PaymentStopped"] = "paymentStopped";
  InvoiceStatusEnum["PaymentDisputed"] = "paymentDisputed";
  return InvoiceStatusEnum;
}({});